import BaseStyle from '@primevue/core/base/style';

var classes = {
  root: 'p-steplist'
};
var StepListStyle = BaseStyle.extend({
  name: 'steplist',
  classes: classes
});

export { StepListStyle as default };
//# sourceMappingURL=index.mjs.map
